/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import CkPage from "../../../components/CkPage";
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../../../components/Iconfont/Iconfont";



class RegisterCheckinGuidePage extends React.Component {
    state = {
        animated: ''
    };

    render() {
        const ckPageContent = <div style={{backgroundColor:'#fff',padding:16}}>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#EC6A59'}}  libname="ckicon" type="shuzisucai3"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>该服务需要会员权限，请去</span>
                    <Button  type="primary" ghost  onClick={()=>{
                    this.props.router.push("/admin/mall/products");
                }}>商城购买</Button>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg1.jpg" alt=""/>
            </div>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#9CBC23'}}  libname="ckicon" type="shuzisucai4"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>报名签到趋势统计服务，PC端和手机端都能随时了解报名签到数据，掌握报名签到动态。</span>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/signupstatus-bg.jpg" alt=""/>
            </div>
        </div>

        return (
            <CkPage title={null} content={ckPageContent}/>
        )
    }
}

export default RegisterCheckinGuidePage;


// WEBPACK FOOTER //
// ./src/containers/evt/stats/RegisterCheckinGuidePage.jsx